import React, { useState, memo, useRef, useEffect } from "react";
import classNames from "classnames/bind";
import {
  FullScreenIcon,
  OffStatus,
  OnStatus,
  WeakStatus,
  DownIcons,
  SettingIcon,
} from "../../../../../components/Icons/Icons";
import { CameraContext } from "../../../../LiveCamera/LiveCamera";
import styles from "./Header.module.css";
import { quickSort } from "../../../../../utils";
import { Toast } from "../../../../../components";
import { screens } from "./configScreen";
import { LisencePlateContext } from "../../../../../contexts";
const cx = classNames.bind(styles);

const Header = ({
  setFilter,
  filter,
}) => {
  const {
    isLoadingCamera,
    setCurrentPage,
    screen,
    setScreen,
    isFullScreen,
    setIsFullScreen,
    showTaskbar,
    setShowTaskBar,
    oneThread, setOnThread,
    isGroup,
    setGroupCode
  } = React.useContext(LisencePlateContext);
  const [listNumber, setListNumber] = useState([{
    col: 1,
    row: 1,
    total: 1,
  }]);
  const [showFilter, setShowFilter] = useState(false);
  const ref = useRef();
  const refStatus = useRef();
  const filterStatus = useRef();
  const refBtn = useRef();
  const [col, setCol] = useState(1);
  const [row, setRow] = useState(1);
  const [isShowForm, setIsShowForm] = useState(false);
  const companyCode = sessionStorage.getItem('company_code');
  const handleFullScreen = () => {
    setIsFullScreen(!isFullScreen);
    sessionStorage.setItem("fullScreen", !isFullScreen)
  };
  const changeScreen = (index) => {
    if (!isLoadingCamera) {
      setScreen(index);
      setCurrentPage(1);
      sessionStorage.setItem("col", index.col)
      sessionStorage.setItem("row", index.row)
      sessionStorage.setItem("total", index.total)
    }
  };
  const handleChangeScreen = () => {
    if (col >= 1 && row >= 1) {
      setScreen({
        col: Number(col),
        row: Number(row),
        total: Number(col) * Number(row),
      });
      const newData = quickSort([
        ...listNumber,
        {
          col: Number(col),
          row: Number(row),
          total: Number(col) * Number(row),
        },
      ]);

      // setListNumber(newData);
      setIsShowForm(!isShowForm);
    }
    else {
      Toast.open("Vui lòng chọn hàng với cột tối thiểu 1", "danger")
    }
  };
  React.useEffect(() => {
    let handler = (e) => {
      if (!ref?.current?.contains(e.target) && e.target !== refBtn?.current) {
        setIsShowForm(false);
      }
    };

    document.addEventListener("click", handler);

    return () => {
      document.removeEventListener("click", handler);
    };
  }, []);
  React.useEffect(() => {
    let handler = (e) => {
      if (
        !filterStatus?.current?.contains(e.target) &&
        !refStatus?.current?.contains(e.target)
      ) {
        setShowFilter(false);
      }
    };

    document.addEventListener("click", handler);

    return () => {
      document.removeEventListener("click", handler);
    };
  }, []);
  // console.log(listNumber);
  return (
    <div
      className={cx("content", isFullScreen ? "full" : "")}
      style={
        isFullScreen
          ? showTaskbar
            ? {}
            : {
              display: "none",
            }
          : {}
      }
    >
      {!isFullScreen && (
        <div className={cx("left")}>
          <h2 className={cx("title")}>Xem trực tiếp</h2>
        </div>
      )}
      <div className={cx("right")}>
        <div className={cx("custom")}>
          <span
            style={
              isFullScreen
                ? {
                  color: "white",
                }
                : {}
            }
            className={cx("text")}
          >
            Màn hình hiển thị
          </span>
          {listNumber &&
            listNumber.map((item, index) => (
              <span
                key={index}
                onClick={(e) => changeScreen(item)}
                className={cx(
                  "number",
                  (screen?.total === item?.total || sessionStorage.getItem("total") === item?.total) ? "active" : ""
                )}
              >
                {item.total}
              </span>
            ))}
          {isShowForm && (
            <div
              ref={ref}
              className={cx(isFullScreen ? "form_full" : "form")}
              style={{ position: "absolute" }}
            >
              <div className={cx("form-group")}>
                <label>Cột</label>
                <input
                  className={cx("input")}
                  onChange={(e) => setCol(e.target.value)}
                  type="number"
                  value={col}
                  min={1}

                />
              </div>
              <div className={cx("form-group")}>
                <label>Hàng</label>
                <input
                  className={cx("input")}
                  onChange={(e) => setRow(e.target.value)}
                  type="number"
                  value={row}
                  min={1}
                />
              </div>
              <button onClick={handleChangeScreen} className={cx("access")}>
                Xác nhận
              </button>
              <button
                onClick={(e) => setIsShowForm(!isShowForm)}
                className={cx("cancel")}
              >
                Hủy bỏ
              </button>
            </div>
          )}
        </div>
        <div className={cx("full-screen")}>
          <span
            style={
              isFullScreen
                ? {
                  color: "white",
                }
                : {}
            }
            className={cx("text")}
          >
            {isFullScreen ? "Thu nhỏ màn hình" : "Toàn màn hình"}
          </span>
          <span onClick={handleFullScreen} className={cx("icon")}>
            {isFullScreen ? (
              <FullScreenIcon color="white" />
            ) : (
              <FullScreenIcon color="black" />
            )}
          </span>
        </div>
      </div>
    </div>
  );
};


export default memo(Header);
